import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import useNavigation from '@/hooks/useNavigation';

interface SidebarDisclosureValue {
  openId: string | null;
  setOpen: (_id: string, _isOpen: boolean) => void;
}

const SidebarDisclosureContext = createContext<SidebarDisclosureValue>({
  openId: null,
  setOpen: () => {},
});

export const useSidebarDisclosure = () => useContext(SidebarDisclosureContext);

export const SidebarDisclosureProvider = ({
  activeParentId,
  children,
}: {
  activeParentId: string | null;
  children: React.ReactNode;
}) => {
  const navigation = useNavigation();
  const [manualOpenId, setManualOpenId] = useState<string | null>(null);

  useEffect(() => {
    setManualOpenId(null);
  }, [navigation.asPath]);

  const setOpen = useCallback((id: string, isOpen: boolean) => {
    setManualOpenId(isOpen ? id : '');
  }, []);

  const value = useMemo(
    () => ({ openId: manualOpenId ?? activeParentId, setOpen }),
    [activeParentId, manualOpenId, setOpen],
  );

  return (
    <SidebarDisclosureContext.Provider value={value}>{children}</SidebarDisclosureContext.Provider>
  );
};
